export const ClubViajemosLogo = ({ className = "", size = "default" }) => {
  return null;
};

export const ClubViajemosLogoFull = ({ className = "" }) => {
  return (
    <a href="/" className={`flex items-center shrink-0 group ${className}`} data-testid="home-logo">
      <img
        src="/clubviajemos-logo.png"
        alt="Club Viajemos"
        className="h-16 sm:h-20 w-auto object-contain group-hover:scale-[1.03] transition-transform"
      />
    </a>
  );
};

// Text-only logo for different sizes
export const ClubViajemosText = ({ className = "", size = "default" }) => {
  const sizes = {
    small: "text-lg",
    default: "text-xl", 
    large: "text-3xl",
    hero: "text-4xl sm:text-5xl"
  };

  const textSize = sizes[size] || sizes.default;

  return (
    <h1 className={`font-extrabold tracking-tight text-[#1D1D1B] dark:text-white ${textSize} ${className}`}>
      Club<span className="text-[#45A0EE]">Viajemos</span>
    </h1>
  );
};

export default ClubViajemosLogo;
